import flagsmith from '../../../node_modules/.pnpm/flagsmith@3.18.1/node_modules/flagsmith/index.js';
import { REMOTE_CONFIG_COOKIE_NAME } from '../../config.js';
import { getCookie, setCookie } from '../../utils/cookie.js';
import { LogSentryMessage } from '../sentryLogger/sentryLogger.js';

class RemoteConfigClient {
    DOMAIN = "shapr3d.com";
    cachedConfig = {};
    overrideConfig = {};
    remoteOnlyConfig = {};
    constructor({ environmentID, identityID, traits }) {
        this.cachedConfig = this.getCachedConfig();
        flagsmith.identify(identityID, traits);
        flagsmith.init({
            environmentID,
            preventFetch: true,
            api: "https://edge.api.flagsmith.com/api/v1/",
            onError: (error) => {
                LogSentryMessage({
                    message: "Flagsmith error",
                    level: "info",
                    extra: { error },
                });
            },
        });
    }
    updateCachedConfig(newConfig) {
        const cachedConfig = this.getCachedConfig();
        const cachedKeys = Object.keys(cachedConfig).sort();
        const remoteKeys = Object.keys(newConfig).sort();
        const staleKeys = cachedKeys.filter((x) => !remoteKeys.includes(x));
        staleKeys.forEach((key) => delete cachedConfig[key]);
        const newKeys = remoteKeys.filter((x) => !cachedKeys.includes(x));
        newKeys.forEach((key) => (cachedConfig[key] = newConfig[key]));
        const crossDeviceKeys = remoteKeys.filter((key) => key.endsWith("-cd"));
        crossDeviceKeys.forEach((key) => (cachedConfig[key] = newConfig[key]));
        this.setCachedConfig(cachedConfig);
    }
    async identify(identityID, traits) {
        await flagsmith.identify(identityID, traits);
        this.processConfig();
    }
    setFlags(flags) {
        flagsmith.setState({ ...flagsmith.getState(), flags });
        this.processConfig();
    }
    processConfig() {
        const configs = flagsmith.getState().flags;
        if (configs && Object.keys(configs).length > 0) {
            const remoteConfig = {};
            Object.entries(configs).forEach(([name, { value, enabled }]) => {
                if (name.endsWith("-ff")) {
                    this.remoteOnlyConfig[name] = enabled && value !== false;
                }
                else {
                    if (enabled) {
                        remoteConfig[name] = value?.toString() ?? "control";
                    }
                }
            });
            this.updateCachedConfig(remoteConfig);
        }
    }
    getCachedConfig() {
        const cookie = getCookie(REMOTE_CONFIG_COOKIE_NAME);
        return cookie ? JSON.parse(cookie) : {};
    }
    setCachedConfig(config) {
        this.cachedConfig = config;
        setCookie(REMOTE_CONFIG_COOKIE_NAME, JSON.stringify(config), 24 * 7, this.DOMAIN);
    }
    addOverride(configName, configValue) {
        this.overrideConfig[configName] = configValue;
    }
    removeOverride(configName) {
        delete this.overrideConfig[configName];
    }
    getConfig(configName) {
        return this.getAllConfig()[configName];
    }
    getAllConfig() {
        return {
            ...this.remoteOnlyConfig,
            ...this.cachedConfig,
            ...this.overrideConfig,
        };
    }
}

export { RemoteConfigClient };
//# sourceMappingURL=remoteConfigClient.js.map
